import { useEffect, useRef, useState } from 'react';
import Titel from "../../Components/DetailPaint/titel";
import { AxiosPublic } from '../../config/axios';
import Verify from '../../Components/Auth/verify';
import Password from '../../Components/Auth/Password';

const SignIn = () => {
    const [user, setUser] = useState('');
    const [error, setError] = useState();

    const [verifyCom, setVerifyCom] = useState(0)


    const input = useRef(null)

    useEffect(() => {
        if (input.current) {
            input.current.focus()
        }
    }, [input.current])


    const handleSubmit = async (e) => {
        e.preventDefault();
        const pattern = /^([0-9]{11}|[A-Za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3})$/;
        if (!pattern.test(user)) {
            setError('فرمت به درستی وارد نشده است، لطفا از اعداد انگلیسی استفاده کنید')
            return
        }
        setError(null)
        await AxiosPublic.post("/check-user", { user })
            .then(res => {
                setVerifyCom(res.data.data.exists ? 1 : 2)
            })
            .catch(err => {
                setError(err.response?.data.message)
            })
    };

    return (
        <>
            <title>ورود</title>
            <div className="py-12 min-h-[53vh] flex items-center justify-center bg-gray-100" dir="auto">
                {verifyCom ? (verifyCom === 3 ? <Password user={user} setVerifyCom={setVerifyCom} /> : <Verify user={user} exists={verifyCom} setVerifyCom={setVerifyCom} />) : <div className="max-w-md w-full flex flex-col">
                    <div className='bg-white rounded-lg p-8'>
                        <Titel title='ورود | ثبت نام' />
                        <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
                            <div className='flex flex-col gap-4'>
                                <label htmlFor="user" className="block text-sm font-medium text-gray-500">
                                    لطفا شماره موبایل یا ایمیل خود را وارد کنید
                                </label>
                                <input
                                    ref={input}
                                    type="user"
                                    id="user"
                                    value={user}
                                    onChange={(e) => setUser(e.target.value)}
                                    className="mt-1 block w-full px-3 py-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#C3003F] focus:border-[#C3003F] sm:text-sm"
                                />
                            </div>
                            {error && <p className="text-sm text-red-600">{error}</p>}
                            <button className={`text-white centerOfParent h-12 w-full bg-gradient-to-r from-[#C3003F]  to-[#5D001E] hover:bg-gradient-to-br focus:outline-none font-medium rounded-lg text-lg px-5 py-2.5 text-center`}>
                                ورود
                            </button>
                        </form>
                    </div>
                </div>}
            </div>
        </>
    );
};

export default SignIn;
